module.exports = __webpack_public_path__ + "static/img/deal_13.ff1e344b.png";